(ns ui.components.select.async-multi-select
  (:require [ui.components.select.async-select :as async-select]))

(defn view
  [args]
  [async-select/view
   (assoc args
     :is-multi? true)])
